import { CompareGroupMapper } from '../mapper/CompareGroupMapper';

export const compareGroupMapper = new CompareGroupMapper();
